











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveTeam_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArchiveTeamForm_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "4441569747520aa5144ea60075a08d69";

export default node;
